import React from 'react';
import { SelectPicker } from 'rsuite';
import { isMobile } from 'react-device-detect';
import { usePreferences } from '../Preferences/PreferencesContext';
import { getThemeColors } from '../../helpers/themeColors';

const SPACING = {
  sidebarWidth: 220,
  sidebarPadding: 16,
  sidebarBorderRadius: 6,
  sidebarTitleMarginBottom: 8,
  sidebarItemPadding: '6px 0',
  stickyTop: 20,
  headerMarginBottom: 24,
};

const FONT = {
  sidebarTitle: 14,
  sidebarTitleWeight: 600,
  sidebarTitleLetterSpacing: 1,
  sidebarItem: 14,
};

const TRANSITION_DURATION = '0.2s';

const RulesSidebarNav = ({ sections, activeId, onSelect }) => {
  const { preferences } = usePreferences();
  const t = getThemeColors(preferences.theme);

  if (isMobile) {
    // Mobile layout: SelectPicker dropdown
    return (
      <div style={{ marginBottom: SPACING.headerMarginBottom }}>
        <SelectPicker
          data={sections.map((section) => ({
            label: section.label,
            value: section.id,
          }))}
          value={activeId}
          onChange={onSelect}
          placeholder="Jump to section"
          block
          searchable
          style={{
            width: '100%',
          }}
        />
      </div>
    );
  }

  // Desktop layout: fixed-width sidebar with list
  return (
    <div
      style={{
        width: SPACING.sidebarWidth,
        flexShrink: 0,
        position: 'sticky',
        top: SPACING.stickyTop,
      }}
    >
      <div
        style={{
          backgroundColor: t.cardBackground,
          border: `1px solid ${t.borderPrimary}`,
          borderRadius: SPACING.sidebarBorderRadius,
          padding: SPACING.sidebarPadding,
        }}
      >
        <div
          style={{
            fontSize: FONT.sidebarTitle,
            color: t.accentPrimary,
            fontWeight: FONT.sidebarTitleWeight,
            marginBottom: SPACING.sidebarTitleMarginBottom,
            textTransform: 'uppercase',
            letterSpacing: FONT.sidebarTitleLetterSpacing,
          }}
        >
          Contents
        </div>
        {sections.map((section) => (
          <div
            key={section.id}
            role="button"
            tabIndex={0}
            onClick={() => onSelect(section.id)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onSelect(section.id);
              }
            }}
            style={{
              fontSize: FONT.sidebarItem,
              color: section.id === activeId ? t.accentPrimary : t.textSecondary,
              padding: SPACING.sidebarItemPadding,
              cursor: 'pointer',
              transition: `color ${TRANSITION_DURATION}`,
              fontWeight: section.id === activeId ? 600 : 'normal',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = t.accentPrimary;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = section.id === activeId ? t.accentPrimary : t.textSecondary;
            }}
          >
            {section.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RulesSidebarNav;
